export default "__VITE_ASSET__aIWAYOnH__"